import * as Yup from 'yup'
import { store } from "../../stores/Store"
import { Alert } from "../..";
import Ajax from "../../Ajax";
import React from 'react';
import { useFormik } from 'formik';
import { CircularProgress } from '@mui/material';
import { observer } from 'mobx-react-lite';


interface PanelHeaderTitleProps {
    node: any;
    children: any;
}


export default observer(({node, children}: PanelHeaderTitleProps) => {
    
    const [saveScheduled, setSaveScheduled] = React.useState(false)
    const autoSaveTimer = React.useRef<NodeJS.Timeout>()
    var endpointTypeName = null
    var nameKey = "name"

    switch (node.typeName) {
        case "Aora.Platform.Data.CaseNode":
            endpointTypeName = "case"
            break
        case "Aora.Platform.Data.AutomationNode":
            endpointTypeName = "automation"
            break
        case "Aora.Platform.Data.AccountNode":
        case "Aora.Nationality.Data.SponsorAccountNode":
            endpointTypeName = "account"
            nameKey = "accountName"
            break
        // case "Aora.Nationality.Data.SponsorNode":
        //     endpointTypeName = "sponsor"
        //     nameKey = "sponsorName"
        //     break
        case "Aora.Platform.Data.FolderNode":
            endpointTypeName = "folder"
            break
        case "Aora.Nationality.Data.JobNode":
            endpointTypeName = "job"
            nameKey = "title"
            break
        default:
            break
    }

    const formik = useFormik({
    
        initialValues: {
            [nameKey]: node[nameKey],
        },
        validationSchema: Yup.object({
            [nameKey]: Yup.string().required("This field is required"),
        }),

        onSubmit: async (values, actions) => {
            var updatedNode = {...node, [nameKey]: values[nameKey]}
            
            if (endpointTypeName === "job") { 
                store.NodeStore.updateOrEditProcedure(async () => {
                    await Ajax.Entity.SaveEdit(updatedNode)
                })
            } else {
                await Ajax.Node.Edit(endpointTypeName, updatedNode).then(response => {
                    store.NodeStore.refreshFolderNode()
                }).catch((response) => {
                    Alert({message: response.data?.detail ? response.data.detail : "Update failed"})
                })

                setSaveScheduled(false)
            }
        }
    })

    const scheduleSave = () => {
        setSaveScheduled(true)

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }
        autoSaveTimer.current = setTimeout(async () => {
            await formik.handleSubmit()
            clearTimeout(autoSaveTimer.current)
        }, 2000)
    }

    return (
        <div style={{display: "flex", gap: "10px", justifyContent: "space-between"}}>
            {endpointTypeName ? (
                <input 
                    disabled={!!store.AppStore.sessionState || formik.isSubmitting}
                    style={{fontSize: "17px", fontWeight: "600"}}
                    name={nameKey}
                    value={formik.values[nameKey]} 
                    placeholder="Enter new name..."
                    onChange={e => {
                        formik.handleChange(e)
                        scheduleSave()
                    }} />
            ) : (
                <h3 className="trunc-ellipsis" style={{width: "100%", marginRight: "auto"}}>
                    {store.NodeStore.getDisplayName(node)}
                </h3>
            )}

            {saveScheduled ? (
                <div style={{width: "min-content", display: "flex", gap: "8px", fontSize: "14px", fontWeight: "300", alignItems: "center"}}>
                    <CircularProgress style={{width: "8px", height: "8px"}} />
                    <span className="font-grey">Saving...</span>
                </div>
            ) : (
                <>
                    {children}
                </>
            )}
        </div>
    )
})